<template>
  <div id="ooowin">
    <PageHeader></PageHeader>
    <PageCenter>
			 <div class="resourse-wap mt80 w1200" >
			    <div class="nav-menu-search-box" style="padding-top: 42px;">
						<div class="catagory-item">
							<div class="item-left">资料分类:</div>
							<div class="item-right">
								<ul>
									<li @click="menuChange(2)" :class="{ active:type!=0 && isActive2 }" 			
										onselectstart="return false" style="-moz-user-select:none;">技能视频</li>
									<li @click="menuChange(1)" :class="{ active:type!=0 && isActive1 }" 
										onselectstart="return false" style="-moz-user-select:none;">秒懂百科</li>
								</ul>
							</div>
						</div>
						<div class="catagory-item">
							<div class="item-left">关键词搜索:</div>
							<div class="item-right">
								<Input clearable v-model="nameSearchModel" placeholder="请输入关键字" @on-enter="doSearchHandle"  style="display:inline-block;width:200px;margin-right:20px"/>
						  	<button class="do-search-btn"  @click="doSearchHandle" style="display:inline-block">搜索</button>
							</div>
						</div>
					</div>
			 </div>

			 <div class="resource-list-box w1200" v-if="resourseList.length > 0">
			 	  <div class="list-header">
						<span  class="rectangle" ></span>	<span class="text">全部资料</span>
					</div>
					<div class="list-body">
							<div class="card-item" @click="goToDetail(item.id)" v-for="(item,index) of resourseList" :key="index" :style="{'margin-right': ((index+1)%5==0)?'0':'24px'}">
								<img class="item-img" :src="item.coverUrl?item.coverUrl:getQiniuThumbnail(item.videoUrl)" alt="">
								<p class="item-name oneline-ellipsis">{{item.name}}</p>
							</div>
						
					</div>
					<div class="list-footer">
						 <Page class="fr" :total="totalSize" :page-size = "10" :current="pageNum" @on-change="pageChangeHandle"/>
					</div>
			 </div>


			 <div class="no-cont" v-if="resourseList.length == 0">
					<div class="icon-img-no"><img src="@images/icon/logo_no.png" /> </div>
					<p>找不到符合条件的项目...</p>
       </div>


      <div class="clearfix" style="width:100%;height:80px"></div>
    </PageCenter>
    <PageFooter></PageFooter>
  </div>
</template>
<script>
import PageHeader from '@components/common/newHeader.vue';
import PageFooter from '@components/common/PageFooter.vue';
import PageCenter from '@components/common/PageCenter.vue';


export default {
	name: 'app',
	data() {
		return {
			// 按关键字搜索
			nameSearchModel:'',
			isClicked:false,
			isActive:false,
			isActive1:false,
			isActive2:false,
			type:0,		
			hasData: true,
			totalSize:0,
			pageNum:1,
			resourseList:[],
			testArr:[1,2,3,4,5,6,7,8,9,10,11]
		};
	},

	mounted: function() {
		// 获取教学参考资料 1 秒懂百科 2技能视频1
		this.getDataList(1,10,0);
	},

	methods: {
		dbClickHandle(){
			return false;
		},
		menuChange(type){
			this.type = type;
			if(type==1){
				this.isActive1 = !this.isActive1;
				if(this.isActive2){
					this.isActive2 = !this.isActive1;
				}
			
			}else if(type==2){
				this.isActive2 = !this.isActive2;
				if(this.isActive1){
					this.isActive1 = !this.isActive2;
				}
			}	

			if(type==1&&this.isActive1&&!this.isActive2){
				this.getDataList(1,10,1)
			}else if(type==2&&this.isActive2&&!this.isActive1){
				this.getDataList(1,10,2)
			}else if(!this.isActive2&&!this.isActive1){
				this.type = 0;
				this.getDataList(1,10,0)
			}


		},
		///web/reference/selectReferenceMaterial
		getDataList(pageNum,pageSize,type){
			let postData = {}
			//let type = this.type;
			if(type == 1 || type == 2){
				postData.category  = type;
			}else{
				postData.category  = 0;
			}
			postData.name = this.nameSearchModel;
			postData.pageNum = pageNum;
			postData.pageSize = pageSize;
			postData.status = 1;

			let ret = this.ajax.postJSON('/web/reference/selectReferenceMaterial', postData);
			ret.then(res => {
				if (res.code == 1) {
					let data = res.data || {};
					this.resourseList = data.list || [];
					this.totalSize = data.total || 0;
					this.pageNum = pageNum;

				}
			});
		},
		doSearchHandle(){
			console.log(this.nameSearchModel);
			this.getDataList(1,10,this.type);
		},
		pageChangeHandle(pageNum){
			this.getDataList(pageNum,10,this.type);
		},
		goToDetail(id){
			window.location.href = "/resource_detail.html?id="+id
			                       
		}
		,getQiniuThumbnail(url){
			if(!!url){
			  return url + "?vframe/png/offset/1/w/220/h/124"
			}else{
				return ""
			}
			
		}

	},
	components: {
		PageHeader,
		PageFooter,
		PageCenter
	},
};
</script>
<style lang="scss">

.mt80 {
	margin-top: 80px;
}

.catagory-item{
	display: table;
  margin-bottom: 20px;

	  .item-left{
      display: table-cell;
      width: 120px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #555555;
    }

    .item-right{
      display: table-cell;
			width: 600px;

			ul {
				li{
					display: inline-block;
					font-size:16px;
					font-weight:400;
					color:rgba(136,136,136,1);
					margin-right: 40px;
					cursor: pointer;
				}

				li.active{
					color:rgba(245,175,54,1);
					cursor: auto;
				}
			}

    }
}

.do-search-btn {
	width: 100px;
	height: 40px;
	background-color: #f3ae44;
	border-radius: 20px;
	font-size: 16px;
	color: #ffffff;
}

.noresult-box{
	text-align: center;
	margin-top: 140px;
	margin-bottom: 200px;
	p{
		font-size: 16px;
		color:#888888;
		margin-top: 10px;
	}
}
.no-cont{
	text-align: center;
	padding: 40px 0;
}

.resource-list-box{

	border-top:1px solid rgba(240,240,240,1);
	padding: 40px 0;
  margin-top: 40px;

	.list-header {
		padding-bottom: 40px;

		.rectangle{
			display: inline-block;
			width:10px;
			height:20px;
			background:rgba(245,175,54,1);
			border-radius:5px;
			margin-right: 20px;
		}
		.text{
			font-size:22px;
			font-weight:400;
			color:rgba(85,85,85,1);
		}
	}
	.list-body{
		.card-item{
			float: left;
			margin-bottom: 30px;
			margin-right: 24px;
			cursor: pointer;
		
			.item-img{
				display: inline-block;
				width:220px;
				height:124px;
				border-radius:5px;
				border: 1px solid rgba(189,189,189,1);

			}
			.item-name{
				width:220px;
				font-size:16px;
				font-weight:400;
				color:rgba(85,85,85,1);
				height: 30px;
				line-height: 30px;
				padding-left: 2px;
			}
		}

	}
	.list-footer{
		clear: both;
	}

}
</style>
